import { ReactNode } from 'react'

type TemplateGroupProps = {
  name: string
  children: ReactNode
}

export function TemplateGroup({ name, children }: TemplateGroupProps) {
  return (
    <div className="mb-5 flex flex-col overflow-hidden rounded-md bg-offwhite shadow">
      <div className="border-b bg-muted p-2 font-semibold">{name}</div>
      <div className="grid grid-cols-[max-content_minmax(0,1fr)_min-content_min-content] items-center gap-x-1 gap-y-2 overflow-hidden p-2 text-xs">
        {children}
      </div>
    </div>
  )
}
